<template>
  <div class="">
    <div class="row mt-3 mb-3">
      <div class="col">
        <Speaker submission_id="0" area="home" textkey="info_top"></Speaker>
      </div>
    </div>
    <div class="card col p-0 d-flex mb-3" v-for="(submission, index) in submissions">
      <h4 class="card-header">
        <div class="row" v-if="submission.showOnlineConfirmation === false">
          <div class="col d-flex">
            <div class="my-auto">
              {{ submission.name }}
            </div>
          </div>
          <div class="w-100 d-block d-sm-none"></div>
          <div class="col col-sm-4">
            <div class="smaller my-auto float-sm-right">
              <div class="mr-3">
                <span class="text-danger" v-if="!submission.isOpen"><icon :icon="['fad', 'lock']" class=""/> {{wording[0].home.submission_closed}}</span>
                <span class="text-success" v-else><icon :icon="['fad', 'lock-open']"
                                                        class=""/> {{ wording[0].home.submission_open }}</span>
              </div>
              <icon :icon="['fal', 'calendar-times']" class="text-danger"/>
              Deadline: {{ submission.show_stop_date | moment(wording[0].home.dateformat) }}
            </div>
          </div>
        </div>
        <div class="row" v-if="submission.showOnlineConfirmation === true">
          <div class="col d-flex">
            <div class="my-auto">
              {{ submission.name }} {{ wording[0].home.suffix_confsystem }}
            </div>
          </div>
          <div class="w-100 d-block d-sm-none"></div>
          <div class="col col-sm-4">
            <div class="smaller my-auto float-sm-right">
              <div class="mr-3">
                <span class="text-danger" v-if="!submission.isConfirmationOpen"><icon :icon="['fad', 'lock']" class=""/> {{ wording[0].home.submission_closed }}</span>
                <span class="text-success" v-else><icon :icon="['fad', 'lock-open']" class=""/> {{ wording[0].home.submission_open }}</span>
              </div>
              <icon :icon="['fal', 'calendar-times']" class="text-danger"/>
              Deadline: {{ submission.confirm_stop_date | moment(wording[0].home.dateformat) }}
            </div>
          </div>
        </div>

        <!--        <button class="btn btn-link mr-auto" type="button" data-toggle="collapse"-->
        <!--                :data-target="'#submission'+submission.id"-->
        <!--                aria-expanded="false" :aria-controls="slugify(submission.name)">-->
        <!--          <span class="when-opened"> <icon :icon="['fas', 'chevron-down']"/> </span>-->
        <!--          <span class="when-closed"> <icon :icon="['fas', 'chevron-right']"/> </span>-->
        <!--          {{submission.name}}-->
        <!--          <span class="badge badge-pill badge-dark" v-if="!isSubmissionClosed(submission.stop_date)">Closed</span>-->
        <!--          <span class="badge badge-pill badge-success" v-else>Open</span>-->
        <!--        </button>-->
      </h4>
      <div :id="'submission'+submission.id">
        <div class="card-body" v-if="submission_abstracts">
          <Speaker :submission_id="submission.id" area="home"
                   textkey="guidelines"></Speaker>
          <div v-if="submission_abstracts[submission.id]">
            <div>
              <AbstractTable v-bind:initialAbstracts="submission_abstracts[submission.id]"
                             v-bind:submission_id="submission.id"
                             v-bind:isOpen="submission.isOpen"
                              @openaccess="openAccessCode($event)"
              />
            </div>
          </div>
          <!--
          <div class="list-group-item list-group-item-action p-2"
               v-if="submission.isOpen">
            <div class="row d-flex">
              <div class="col">
                <div class="row">
                  <div class="col d-flex"
                       v-if="!getSettings(submission.id).maxAbstracts || (getSettings(submission.id).maxAbstracts && submission_abstracts[submission.id].length < getSettings(submission.id).maxAbstracts)">
                    <button type="button" v-if="submission.access_code && submission.access_code.length > 0"
                            class="btn text-white bg-success"
                            v-on:click="openAccessCode({submissionid: submission.id,abstractid: 0});">
                      <icon :icon="['fas', 'plus-circle']" size="xs"/>
                      {{ wording[0].buttons.new_submission }}
                    </button>
                    <button type="button" v-else class="btn text-white bg-success"
                            v-on:click="checkNewAbstract(submission.id);">
                      <icon :icon="['fas', 'plus-circle']" size="xs"/>
                      {{ wording[0].buttons.new_submission }}
                    </button>
                  </div>
                  <div class="col d-flex" v-else>
                    <div class="col alert alert-info mb-0 pl-0">
                      <div class="row">
                        <div class="col-2 col-sm-1 d-flex">
                          <icon :icon="['fad', 'exclamation-circle']" class="fa-2x mx-auto my-auto"/>
                        </div>
                        <div class="col-10 col-sm-8 d-flex">
                          <div class="row my-auto">
                            <div class="col d-flex my-auto">
                              <Speaker :submission_id="submission.id" area="home"
                                       textkey="max_abstracts"></Speaker>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          -->
        </div>
      </div>

    </div>
    <!-- Modal DRAFT CHECK-->
    <div class="modal fade" id="alreadyDraftModal" tabindex="-1" role="dialog"
         aria-labelledby="alreadyDraftModalTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="alreadyDraftModalTitle">{{ wording[0].home.modal_draft_title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Speaker submission_id="0" area="home" textkey="modal_draft_text"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-dismiss="modal">{{ wording[0].buttons.abort }}</button>
            <button type="button" v-on:click="newAbstract(newAbstractSubmissionId);" class="btn btn-success"
                    data-dismiss="modal">{{ wording[0].buttons.create }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="dataPrivacyAgreementModal" tabindex="-1" role="dialog"
         aria-labelledby="dataPrivacyAgreementModalTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="dataPrivacyAgreementModalTitle">
              {{ wording[0].home.modal_dsgvo_title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <Speaker submission_id="0" area="home" textkey="modal_dsgvo_text"/>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-dismiss="modal">{{ wording[0].buttons.cancel }}</button>
            <button type="button" v-on:click="newAbstract(newAbstractSubmissionId);" class="btn btn-success"
                    data-dismiss="modal">{{ wording[0].buttons.confirm }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="accessCodeModal" tabindex="-1" role="dialog"
         aria-labelledby="accessCodeModalTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="accessCodeModalTitle">
              {{ wording[0].home.modal_accesscode_title }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row" v-if="accessCodeError === true">
              <div class="col">
                <div class="alert alert-danger">
                  The code you entered is incorrect.
                </div>
              </div>
            </div>
            <Speaker submission_id="0" area="home" textkey="modal_accesscode_text"/>
            <div class="row">
              <div class="col form-inline">
                <div class="form-group">
                  <label for="accesscode">
                    <Speaker submission_id="0" area="home" textkey="modal_accesscode_label"/>
                  </label>&nbsp;
                  <input type="text" class="form-control" id="accesscode" aria-describedby=""
                         v-on:keydown.enter="checkAccessCode()"
                         v-model="accessCode">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-warning" data-dismiss="modal">{{ wording[0].buttons.cancel }}</button>
            <button type="button" v-on:click="checkAccessCode()" class="btn btn-success">{{
                wording[0].buttons.confirm
              }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AbstractTable from '../components/AbstractsTable';
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'
import Speaker from "../components/helpers/Speaker";

export default {
  components: {
    Speaker,
    'AbstractTable': AbstractTable
  },
  computed: {
    ...mapState([
      'submission_abstracts', 'status', 'types', 'submissions', 'wording', 'user', 'validation', 'authorvalidation', 'processing', 'settings', 'mode'
    ]),
    ...mapGetters(['getSettings', 'getFirstCurrentPage'])
  }
  ,
  methods: {
    ...mapActions([
      'CREATE_ABSTRACT', 'GET_USERDATA'
    ]),
    ...mapMutations([
      'SET_USER'
    ]),
    countAbstracts: function () {
      let draft = abstracts['draft'];
      let submitted = abstracts['submitted'];
      return draft.length + submitted.length;
    },
    isSubmissionClosed(timestamp) {
      let stopTime = new Date(timestamp);
      return stopTime.getTime() >= Date.now();
    },
    openAccessCode(event) {
      this.accessCode = '';
      this.accessCodeError = false;
      this.newAbstractSubmissionId = event.submissionid;
      this.editAbstractId = event.abstractid;
      $('#accessCodeModal').modal('show');
    },
    checkAccessCode() {
      let submission = this.submissions.find(submission => submission.id === this.newAbstractSubmissionId);
      let myabstractID = this.editAbstractId;
      if (this.accessCode === submission.access_code ) {
        if(myabstractID == 0){
          $('#accessCodeModal').modal('hide');
          this.checkNewAbstract(this.newAbstractSubmissionId);
        }
        else if (myabstractID > 0){
          $('#accessCodeModal').modal('hide');
          this.$router.push('abstract/' + this.editAbstractId + '/dynamic/' + this.getFirstCurrentPage(this.newAbstractSubmissionId).id);
        }
      }
      this.accessCodeError = true;
      return false;
    },
    checkNewAbstract(submission_id) {
      this.newAbstractSubmissionId = submission_id;
      if (this.submission_abstracts[submission_id].filter(abstract => abstract.status_id === 1).length > 0) {
        $('#alreadyDraftModal').modal('show');
      } else {
        $('#dataPrivacyAgreementModal').modal('show');
      }
    },
    newAbstract: function (submission_id) {
      let template = {
        "setting_submission_id": submission_id,
        "reference_number": this.getSettings(submission_id).reference_number,
        "content": {},
        "status_id": 1
      };
      this.CREATE_ABSTRACT(template).then((response) => {
        this.$noty.success(this.wording[0].notify.save_success);
        this.$router.push('abstract/' + response.data.id + '/dynamic/' + this.getFirstCurrentPage(submission_id).id)
      }).catch((error) => {
        this.$noty.error(this.wording[0].notify.save_not_success);
      });
    }
  },
  created() {
    this.processing.validation = false;
    this.processing.author = false;
    this.processing.dynamicdata = false;
    this.processing.rulex = false;

    this.validation.errors = [];
    this.validation.is_checked = false;
    this.validation.status = false;

    this.authorvalidation.errors = [];
    this.authorvalidation.is_checked = false;
    this.authorvalidation.status = false;

    this.mode.confirm = false;

    this.GET_USERDATA().then((result) => {
      this.SET_USER({user: result.data})
      this.submissions.forEach((subitem, index) => {
        this.$store.dispatch('GET_ABSTRACTS', subitem.id);
      });
    })
  },
  data() {
    return {
      newAbstractSubmissionId: 0,
      accessCodeError: false,
      accessCode: ''
    };
  }
}
</script>

<style scoped>
.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
</style>
